export default __webpack_public_path__ + "fonts/plan-batchdialer.svg";